import { render } from "./PasswordPolicy.vue?vue&type=template&id=9ff465c2"
import script from "./PasswordPolicy.vue?vue&type=script&lang=js"
export * from "./PasswordPolicy.vue?vue&type=script&lang=js"

import "./PasswordPolicy.vue?vue&type=style&index=0&id=9ff465c2&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__